import createBreakpoints from '../context/theme/functions/create-breakpoints';

export default (...args) => {
  const { keys, values } = createBreakpoints();
  const breakpoints = args.filter(arg => keys.includes(arg)) || keys;

  const index = [...values]
    .reverse()
    .findIndex(value => value <= window.innerWidth);
  const key = keys.reverse()[index];

  return breakpoints.findIndex(breakpoint => breakpoint === key) > -1;
};
